import { api } from "./client";

export const CmdbAPI = {
  listEntities: () => api.get("/cmdb/entities"),
  getGraph: cmdbEntityId => api.get("/cmdb/graph", { params: { cmdb_entity_id: cmdbEntityId } }),
  createEntity: payload => api.post("/cmdb/entities", payload),
  updateEntity: (id, payload) => api.patch(`/cmdb/entities/${id}`, payload),
  deleteEntity: id => api.delete(`/cmdb/entities/${id}`),
  setEntityAssets: (id, assetIds) => api.put(`/cmdb/entities/${id}/assets`, { asset_ids: assetIds }),
};
